export const Options = {
    Salutation: [
        { text: "Frau", value: "w" },
        { text: "Herr", value: "m" },
        { text: "Divers", value: "d" },
    ],
    BecomingAwareThrough: [
        { text:"Arbeitsagentur", value:"Arbeitsagentur"},
        { text:"Außenwerbung", value:"Außenwerbung"},
        { text:"Headhunter", value:"Headhunter"},
        { text:"Homepage", value:"Homepage"},
        { text:"Indeed", value:"Indeed"},
        { text:"Jobmesse", value:"Jobmesse"},
        { text:"Kununu", value:"Kununu"},
        { text:"LinkedIn", value:"LinkedIn"},
        { text:"Printmedien", value:"Printmedien"},
        { text:"Social Media", value:"Social Media"},
        { text:"Stepstone", value:"Stepstone"},
        { text:"Xing", value:"Xing"},
        { text:"Sonstiges", value:"Sonstiges"},
    ]
}
